import { GoogleOAuthProvider } from '@react-oauth/google';
import { FACEBOOK_OA_ID, GOOGLE_CLIENT_ID } from 'globalConstants';
import { FacebookProvider } from 'react-facebook';
import Footer from '../shared/footer';
import Header2 from '../shared/header2';
import LeftSection from './left-section';
import RightSection from './right-section';

const SignIn = () => (
  <FacebookProvider appId={FACEBOOK_OA_ID}>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <Header2 />
      <main className='flex min-h-[1000px] min-w-[1052px] flex-col'>
        <div className='my-[28px] flex flex-col space-y-[28px]'>
          <div className='container mx-auto flex min-w-[1052px] flex-col items-center px-[54px] screen-1140:px-[98px] xl:px-[48px] screen-1366:px-[83px]'>
            <div className='flex h-[580px] w-[800px] overflow-hidden rounded-[8px] shadow-24'>
              <LeftSection />
              <RightSection />
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </GoogleOAuthProvider>
  </FacebookProvider>
);

export default SignIn;
